import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Trigger = ({ className, children }: Props) => {
    const {
        isActive,
        isOverlayOpen,
        invert,
        invertMobile,
        link,
        ariaLabel,
        onClick
    } = useHeaderButtonContext();

    const classNames = cn(
        "tw:relative tw:whitespace-nowrap",
        "tw:hover:cursor-pointer",
        "tw:lg:p-0",
        "tw:hover:no-underline!",
        {
            "tw:z-20": isActive,
            "tw:text-primary tw:focus:text-primary-focus tw:hover:text-primary-focus":
                !invertMobile,
            "tw:text-white tw:focus:text-white tw:hover:text-white":
                invertMobile,
            "tw:lg:text-primary tw:lg:focus:text-primary-focus tw:lg:hover:text-primary-focus":
                !invert || isOverlayOpen,
            "tw:lg:text-white tw:lg:focus:text-white tw:lg:hover:text-white":
                invert && !isOverlayOpen
        },
        className
    );

    if (!link) {
        return (
            <button
                type={"button"}
                className={classNames}
                onClick={onClick}
                aria-label={ariaLabel}
            >
                {children}
            </button>
        );
    } else {
        return (
            <a
                className={classNames}
                href={link}
                onClick={onClick}
                aria-label={ariaLabel}
            >
                {children}
            </a>
        );
    }
};
